// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2LCNk","description":"styles_description__3T-cT","content":"styles_content__36F88","button":"styles_button__yTAGR"};